<template>
    <div class="select">
        <div :class="{'select-selected': true, isActive: optionsShow}">
            <!-- <input type="text"
                ref="input"
                class="select-input"
                readonly="readonly"
                autocomplete="off"
                @blur="handleSelectInput('blur')"
                @click="handleSelectInput('focus')"
            /> -->
            <div
                tabindex="0"
                ref="input"
                class="select-input"
                readonly="readonly"
                autocomplete="off"
                @blur="handleSelectInput('blur')"
                @click="handleSelectInput('focus')"
            > 
                <div>
                    <div v-if="modelList[selectIdx]" class="selected-value">
                        <p class="selected-name nowrap">{{modelList[selectIdx].modelName}}</p>
                        <p class="selected-price">厂商指导价：{{modelList[selectIdx].manufacturerPrice}}</p>
                    </div>
                </div>
                <i :class="{'isActive': optionsShow, 'c-icon': true}">&#xe614;</i>
            </div>
        </div>
        <div class="select-options"
            :style="optionsStyle"
            @mouseenter="handleMouseEnter('enter')"
            @mouseleave="handleMouseEnter('out')"
        >
            <div class="select-content" ref="content">
                <div
                    v-for="(item, index) in modelList"
                    :key="item.id"
                    :class="{
                        'selected-value': true,
                        options: true,
                        isActive: selectIdx === index
                    }"
                    @click="handleOption(index)"
                >
                    <p class="selected-name">{{item.modelName}}</p>
                    <p class="selected-price">厂商指导价：{{item.manufacturerPrice}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/**
 * @file
 * @author guozhihao02
 */
import {get} from 'lodash';
export default {
    data() {
        return {
            optionsStyle: {},
            optionsShow: false,
            canClose: true
        };
    },
    props: {
        modelList: {
            type: Array,
            default: () => []
        },
        selectIdx: {
            type: Number,
            default: 0
        },
        carInfo: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        handleSelectInput(act) {
            const {offsetHeight} = this.$refs.input;
            if (!this.canClose) {
                return;
            }
            if (act === 'focus' && !this.optionsShow) {
                this.optionsShow = true;
                this.optionsStyle = {
                    top: `${offsetHeight + 6}px`,
                    height: this.$refs.content.offsetHeight + 'px'
                };
                this.$emit(
                    'sendlog',
                    'ask_price_model_down_click',
                    {
                        seriesId: this.carInfo.series_id,
                        modelId: get(this.modelList, `[${this.selectIdx}].modelId`),
                        modelName: get(this.modelList, `[${this.selectIdx}].modelName`)
                    }
                );
                this.$emit('sendubclog', 'selectType', {
                    type: 'show'
                });
            }
            else {
                this.optionsShow = false;
                this.optionsStyle = {
                    top: `${offsetHeight + 6}px`,
                    height: 0
                };
            }
        },
        handleOption(idx) {
            this.canClose = true;
            this.$nextTick(() => {
                this.handleSelectInput('blur');
                this.$emit('onchange', idx);
            });
            this.$emit(
                'sendlog',
                'ask_price_choose_car',
                {
                    pos: idx,
                    brandName: this.carInfo.brand_name,
                    name: this.carInfo.series_name,
                    seriesId: this.carInfo.series_id,
                    modelId: get(this.modelList, `[${idx}].modelId`),
                    modelName: get(this.modelList, `[${idx}].modelName`)
                }
            );
            this.$emit('sendubclog', 'selectType');
        },
        handleMouseEnter(act) {
            this.canClose = act !== 'enter';
            if (act !== 'enter') {
                this.$refs.input.focus();
            }
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;

.select {
    width: 551px;
    position: relative;
    .selected-value {
        display: flex;
        cursor: pointer;
        .selected-name {
            width: 323px;
            &.nowrap {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

        }
        .selected-price {
            margin-left: 14px;
            color: #999999;
        }
        &.options {
            padding: 8px 12px;
            &:hover {
                // background: #F8F8F8;
                background: rgba(0,206,207, .05);
            }
            &.isActive {
                .selected-name {
                    color: @themeColor;
                }
            }
        }
    }
    .select-selected {
        display: flex;
        position: relative;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border: 1px solid #EEEEEE;
        border-radius: 3px;
        color: #333333;
        transition: border .15s linear;
        &.isActive {
            border-color: @themeColor;
        }
        .select-input {
            display: flex;
            height: 100%;
            padding: 0 12px;
            outline: none;
            cursor: pointer;
        }
        div {
            flex: 1;
        }
        i {
            margin-left: 12px;
            /* 关闭双击反色 */
            user-select: none;
            transition: all .2s linear;
            &.isActive {
                transform: rotate(-180deg);
            }
        }
    }
    .select-options {
        position: absolute;
        width: 100%;
        height: 0;
        max-height: 300px;
        overflow-x: hidden;
        overflow-y: scroll;
        transition: height .4s linear;
        border-radius: 3px;
        box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .15);
        background: #FFFFFF;
        z-index: 99;
        .select-content {
            font-size: 16px;
        }
    }
}
</style>